import styled, { css } from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getColor, type Theme } from 'styles/theme';
import Heading from 'styles/typography/Heading';
// import { breakpoint } from 'styles/globals';
// import { getBodyStyle, getColor, Theme } from 'styles/theme';

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;

    @media (${breakpoint.mdMax}) {
      .breadcrumbs,
      .more-rankings {
        padding: 0 20px;
      }
    }

    @media (min-width: 426px) {
      padding: 0px;
    }

    @media (${breakpoint.lgMin}) {
      gap: 48px;
      
      .article-wrapper-topic 
      {
        .title {
          margin-top: 24px;
        }
      }

      &.small-gap {
        .article-wrapper-topic {
          .termArchiveContentList {
            margin-top: 0;
          }
        }
      }
    }
`;

export const LatestWrapper = styled.div`
  @media (${breakpoint.mdMax}) {
    padding: 0 20px;  
  }
`;

export const MoreLink = styled.div<{ theme: Theme; mobileOnly?: boolean }>`
  margin-top: 24px;
  text-align: right;
  
  @media (${breakpoint.mdMin}) {
    margin-top: 0;
    text-align: left;
  }

  display: ${(props) => (props.mobileOnly ? 'block' : 'none')};
  @media (${breakpoint.mdMin}) {
    display: ${(props) => (props.mobileOnly ? 'none' : 'inline-flex')};
  }

  .more-link {
    color: ${getColor('textSecondary')};
    &::after {
      border-color: ${getColor('textSecondary')};
    }
  }
`;
export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  text-transform: capitalize;

  .category-title {
    font-family: ${font.saolText};
  }
`;

const commonPadding = css`
  padding: 0 20px;

  @media (${breakpoint.mdMin}) {
    padding: 0;
  }
`;

export const Header = styled.div<{ $headerHeight?: number }>`
  ${commonPadding}
  ${({ $headerHeight }) => $headerHeight && { scrollMarginTop: `${$headerHeight}px` }};

  @media (${breakpoint.lgMin}) {
    margin-top: -48px;
  }
`;
export const ArticleWrapper = styled.div`
  margin-bottom: 24px;

  @media (${breakpoint.mdMin}) {
    margin-bottom: 0;
  }

  &:not(.latest) {
    section:not(.nativo) {
      margin-top: 24px;
    }
    @media (${breakpoint.mdMin}) {
      section:not(.nativo) {
        margin-top: 40px;
      }
    }
  }

  section.termArchiveContentList ul.nativo-well-1,
  section.termArchiveContentList ul.nativo-well-2,
  section.termArchiveContentList ul.nativo-well-3 {
      margin-top: 0;
  }

  @media (${breakpoint.mdMax}) {

    ul.nativo-well-1 li:empty, 
    ul.nativo-well-2 li:empty, 
    ul.nativo-well-3 li:empty {
      height: calc(100vw) !important;
    }
  }

  @media (${breakpoint.mdMin}) {
    > div {
      margin-right: 0;
    }
  }

  @media (${breakpoint.hybridMin}) {
    width: calc(100% - 360px);
  }

  @media (${breakpoint.xlMin}) {
    margin-bottom: 48px;
  }

  & .show-more {
    display: flex;
    margin-right: auto;
    margin-left: auto;
    font-size: 16px;
    
    &.hidden {
      display:none;
      visibility: hidden;
      pointer-events: none;
    }
  }

  & .spinning-loader {
    margin: auto;
    margin-bottom: 24px;
  }
`;
export const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .right-rail-ad-container {
    @media (${breakpoint.lgMin}) {
      margin-top: 30px;
    }

    &.small-gap {
      @media (${breakpoint.hybridMin}) {
        margin-top: 0;
      }
    }
  }

  @media (${breakpoint.hybridMin}) {
    flex-direction: row;
    gap: 24px;
  }
`;

export const PageInfo = styled(Heading)<{ theme: Theme }>`
  padding-top: 8px;
  align-self: flex-start;
  font-weight: 400;
  line-height: 150%;
`;

export const HeroWrapper = styled.div`
 @media (${breakpoint.mdMax}) {
    padding: 0 20px;
  }
`;
